import React from "react"
import { cn } from "../lib/utils"
import { Skeleton } from "./ui/skeleton"
interface PageLoaderProps {
 variant?:"dashboard"|"table"|"form"|"card"
 className?: string
}

export function PageLoader({ variant ="table", className }: PageLoaderProps) {
 if (variant === "dashboard") {
 return (
 <div className={cn("space-y-6", className)}>
 <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
 {Array.from({ length: 4 }).map((_, i) => (
 <div key={i} className=" rounded-xl border border-border-subtle bg-card p-6 space-y-3">
 <Skeleton className="h-4 w-24"/>
 <Skeleton className="h-8 w-32"/>
 <Skeleton className="h-3 w-20"/>
 </div>
 ))}
 </div>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 {Array.from({ length: 2 }).map((_, i) => (
 <div key={i} className=" rounded-xl border border-border-subtle bg-card p-6 space-y-3">
 <Skeleton className="h-5 w-32"/>
 <Skeleton className="h-48 w-full"/>
 </div>
 ))}
 </div>
 </div>
 )
 }

 if (variant === "form") {
 return (
 <div className={cn("space-y-6 p-6", className)}>
 {Array.from({ length: 6 }).map((_, i) => (
 <div key={i} className="space-y-2">
 <Skeleton className="h-4 w-24"/>
 <Skeleton className="h-10 w-full"/>
 </div>
 ))}
 <div className="flex justify-end gap-3 pt-4">
 <Skeleton className="h-10 w-24"/>
 <Skeleton className="h-10 w-32"/>
 </div>
 </div>
 )
 }

 if (variant === "card") {
 return (
 <div className={cn(" rounded-xl border border-border-subtle bg-card p-6 space-y-4", className)}>
 <Skeleton className="h-5 w-40"/>
 <Skeleton className="h-4 w-64"/>
 <div className="space-y-3 pt-2">
 {Array.from({ length: 3 }).map((_, i) => (
 <Skeleton key={i} className="h-10 w-full"/>
 ))}
 </div>
 </div>
 )
 }

 return (
 <div className={cn(" rounded-xl border border-border-subtle bg-card overflow-hidden", className)}>
 <div className="border-b border-border-subtle bg-muted px-4 py-3">
 <div className="flex gap-4">
 {Array.from({ length: 5 }).map((_, i) => (
 <Skeleton key={i} className="h-4 w-20"/>
 ))}
 </div>
 </div>
 {Array.from({ length: 8 }).map((_, i) => (
 <div key={i} className="flex items-center gap-4 border-b border-border-subtle px-4 py-3 last:border-0">
 {Array.from({ length: 5 }).map((_, j) => (
 <Skeleton key={j} className="h-4 flex-1"/>
 ))}
 </div>
 ))}
 </div>
 )
}
